import _ from 'lodash'

const currenciesByCountryCode = {
  AE: 'AED',
  AU: 'AU',
  BR: 'BRL',
  BS: 'BSD',
  CA: 'CAD',
  GB: 'GB',
  KR: 'KRW',
  MX: 'MX',
  QA: 'QAR',
  SG: 'SGD',
  TR: 'TRY',
  US: 'USD',

  AT: 'EUR',
  BE: 'EUR',
  CY: 'EUR',
  DE: 'EUR',
  EE: 'EUR',
  ES: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  GR: 'EUR',
  HR: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  LV: 'EUR',
  MT: 'EUR',
  NL: 'EUR',
  PT: 'EUR',
  SI: 'EUR',
  SK: 'EUR',
}

export default function getCurrencyForCountryCode(countryCode) {
  const code = _.toUpper(countryCode)
  return currenciesByCountryCode[code] || 'USD'
}



// WEBPACK FOOTER //
// ./src/utilities/currency/getCurrencyForCountryCode.js